import type { TermsData } from './terms.types';

const data: TermsData = {
  seo: {
    title: 'លក្ខខណ្ឌនៃការប្រើប្រាស់ | E-School Cambodia',
    description: 'ស្វែងយល់អំពីលក្ខខណ្ឌនៃការប្រើប្រាស់កម្មវិធីទូរស័ព្ទដៃ E-School Cambodia។',
  },
  hero: {
    badge: 'ឯកសារផ្លូវការ',
    title: 'លក្ខខណ្ឌនៃការប្រើប្រាស់',
    subtitle: 'E-School Cambodia Mobile Application',
  },
  intro: {
    text: 'សួស្ដីបងប្អូនទាំងអស់គ្នា! សូមអរគុណសម្រាប់ការចំណាយពេលចូលមកទំព័រនេះដើម្បីស្វែងយល់បន្ថែមអំពីលក្ខខណ្ឌនៃការប្រើប្រាស់។ ពួកយើងបានបង្កើតកម្មវិធីសម្រាប់ការប្រើប្រាស់លើទូរស័ព្ទដៃផ្ទាល់ខ្លួនដែលផ្ដល់ឲ្យបងប្អូននូវសេវាកម្មដែលជាការជំនួយ ឬបង្វឹកលើខ្លួនឯងដោយផ្ទាល់មកចូលរួមតាមរយៈការទស្សនាវីដេអូនៃវគ្គសិក្សាបំប៉នបន្ថែម ដើម្បីឆ្ពោះទៅភាពជោគជ័យផ្ទាល់ខ្លួន។ បងប្អូនអាចធ្វើការសិក្សាជាប្រចាំនឹងអាចធ្វើការបញ្ជាទិញ មេរៀនបន្ថែមពីមួយទៅមួយ។ <strong>"E-School Cambodia"</strong> គឺជាឈ្មោះនៃកម្មវិធីទូរស័ព្ទដៃ ដែលបងប្អូនអាចទទួលបាននូវមាតិកានៃមេរៀនសម្រាប់ការសិក្សាបន្ថែម ទៅលើចំណេះដឹងទូទៅ និងថ្នាក់ភាសាបរទេស ដើម្បីឲ្យការសិក្សារបស់បងប្អូនកាន់តែមានប្រសិទ្ធភាពជាងមុន។ ជាថ្មីម្ដងទៀតយើងសូមអរគុណចំពោះការអាននិងស្វែងយល់អំពីយើង។',
  },
  sections: [
    {
      number: '១',
      title: 'ការយល់ស្របជាមួយលក្ខខណ្ឌនៃការប្រើប្រាស់',
      paragraphs: [
        'លក្ខខណ្ឌនៃការប្រើប្រាស់នេះរៀបរាប់អំពីការណែនាំក្នុងការប្រើប្រាស់នូវកម្មវិធីទូរស័ព្ទនេះ។ តាមរយៈការចូលប្រើប្រាស់នូវកម្មវិធីទូរស័ព្ទដៃនេះ គឺបងប្អូនយល់ស្របទៅតាមលក្ខខណ្ឌនៃការប្រើប្រាស់របស់យើង។ ប្រសិនបើបងប្អូនមិនទាន់យល់ស្របជាមួយលក្ខខណ្ឌនៃការប្រើប្រាស់របស់យើងទេសូមបងប្អូនកុំបន្តទៅមុខទៀត។ កម្មវិធីលើទូរស័ព្ទដៃ E-School Cambodia ដែលមានសេវាកម្មផ្សេងៗនូវខាងក្នុងត្រូវបានផ្ដល់ជូនដោយក្រុមហ៊ុន <strong>E-SCHOOL (CAMBODIA) CO.,LTD</strong>។',
      ],
    },
    {
      number: '២',
      title: 'ការកែប្រែនូវលក្ខខណ្ឌនៃការប្រើប្រាស់',
      paragraphs: [
        'អ្វីៗក៏ដោយតែងតែមានការប្រែប្រួលហើយយើងក៏ដូច្នោះដែរ។ ការពិតទៅវាមានន័យថាយើងអាចនឹងធ្វើការកែប្រែនូវលក្ខខណ្ឌនៃការប្រើប្រាស់ដែលរួមទាំងគោលការណ៍នៃសិទ្ធិឯកជននិងកិច្ចព្រមព្រៀងដទៃទៀតទៅតាមភាពជាក់ស្ដែងរបស់យើង។ ប៉ុន្តែនៅពេលដែលយើងពិតជាចាំបាច់ត្រូវធ្វើការកែប្រែនូវលក្ខខណ្ឌនៃការប្រើប្រាស់មែននោះ យើងដាច់ខាតនឹងជម្រាបជូនបងប្អូនឲ្យបានជ្រាបតាមរយៈកម្មវិធីទូរស័ព្ទដៃនេះផ្ទាល់ខ្លួន ឬតាមសារអេឡិចត្រូនិកជាដើម(ប្រសិនបើមាន)។ រីឯការកែប្រែថ្មីទាំងនោះនឹងចាប់មានសុពលភាពភ្លាមៗតែម្ដង។ ដូច្នេះហើយ បន្ទាប់ពីមានការកែប្រែកើតឡើងហើយបងប្អូននៅតែបន្តស្រលាញ់យើង ក្នុងការប្រើប្រាស់កម្មវិធីទូរស័ព្ទដៃនេះដដែល មានន័យថាបងប្អូនទទួលស្គាល់ និងបន្តយល់ស្របជាមួយការផ្លាស់ប្ដូរនោះ ហើយយើងក៏សូមអរគុណជាថ្មីម្ដងទៀតទុកជាមុន។',
      ],
    },
    {
      number: '៣',
      title: 'ការប្រាស្រ័យទាក់ទងគ្នា',
      paragraphs: [
        'តាមរយៈការប្រើប្រាស់កម្មវិធី E-School Cambodia លើទូរស័ព្ទ បងប្អូនបានយល់ស្រប ក្នុងការទទួលបាននូវការធ្វើទំនាក់ទំនង ទៅកាន់តាមរយៈការផ្ញើសារអេឡិចត្រូនិក សារជូនដំណឹង ឬទូរស័ព្ទដែលពាក់ព័ន្ធទៅនឹងព័ត៌មានអំពីគណនីរបស់បងប្អូននៅក្នុងកម្មវិធីទូរស័ព្ទដៃនេះ។ យើងអាចនឹងធ្វើការទាក់ទងទៅបងប្អូន ដើម្បីណែនាំអំពីរបៀបប្រើប្រាស់ ការពន្យល់អំពីអត្ថប្រយោជន៍ដទៃទៀតដែលមាននៅក្នុងកម្មវិធី ឬដើម្បីបង្ហាញបងប្អូនពីរបៀបនៃការទូទាត់នៃការចូលរួមជាសមាជិកភាព។ល។',
      ],
    },
    {
      number: '៤',
      title: 'គោលការណ៍នៃសិទ្ធិឯកជន',
      paragraphs: [
        'ព័ត៌មានដែលបងប្អូនផ្ដល់មកឲ្យយើង ដែលជាព័ត៌មានអំពីអត្តសញ្ញាណរបស់បងប្អូន អនុលោមទៅតាមគោលការណ៍នៃសិទ្ធិឯកជន ដែលជាលក្ខខណ្ឌបន្ថែម ហើយមានចែងលម្អិតក្នុងទំព័រ <strong>"គោលការណ៍នៃសិទ្ធិឯកជន"</strong>។',
      ],
    },
    {
      number: '៥',
      title: 'សមាជិកភាពនិងការទូទាត់',
      subsections: [
        {
          num: '៥.១',
          title: 'សមាជិកភាព',
          paragraphs: [
            'បងប្អូនត្រូវភ្ជាប់គណនីនៅក្នុងកម្មវិធី ដោយត្រូវមានអ៊ិនធឺណែត និងត្រូវធ្វើការទូទាត់តាមរយៈមធ្យោបាយណាមួយ ដែលយើងមានឲ្យជ្រើសរើស ដើម្បីក្លាយទៅជាសមាជិករបស់កម្មវិធីទូរស័ព្ទ E-School Cambodia។ យើងនឹងធ្វើការគិតប្រាក់សមាជិកភាព នៅដើមគ្រានៃការចូលជាសមាជិក ហើយផ្ដល់ជូនសមាជិកភាពសម្រាប់រយៈពេល១ឆ្នាំ ឬ៣៦៥ថ្ងៃ គិតចាប់ពីថ្ងៃដែលមធ្យោបាយទូទាត់ត្រូវបានជ្រើសរើស និងដំណើរការដោយជោគជ័យ។ ក្រោយពីសមាជិកភាពអស់សុពលភាព បងប្អូនត្រូវធ្វើការជ្រើសរើសចូលជាសមាជិកសារជាថ្មីម្ដងទៀតដោយខ្លួនឯង។ យើងនឹងមិនធ្វើការគិតប្រាក់ពីបងប្អូនដោយបងប្អូនមិនបានជ្រាបជាមុននោះឡើយ។',
          ],
        },
        {
          num: '៥.២',
          title: 'ភាពជាអ្នកប្រើប្រាស់ធម្មតា',
          paragraphs: [
            'ជាទូទៅបងប្អូនដែលទាញយកកម្មវិធីទូរស័ព្ទដៃ E-School Cambodia ពីកម្មវិធីលើប្រព័ន្ធប្រតិបត្តិការណាមួយ (iOS App Store ឬ Android Play Store) អាចចុះឈ្មោះចូលប្រើប្រាស់កម្មវិធីយើងដោយមិនមានតម្រូវឲ្យបង់ប្រាក់អ្វីនោះទេ។ បងប្អូនអាចចូលជាសមាជិកភ្លាមៗបន្ទាប់ពីទាញយកកម្មវិធីយើងបានហើយ ហើយគ្រាន់តែបងប្អូនទាញយកកម្មវិធីយើងដោយឥតគិតថ្លៃ បងប្អូនទទួលបានមេរៀនល្អៗមួយចំនួនរួចជាស្រេចបាត់ទៅហើយ ហើយយើងពិតជាផ្ដល់ជូនដោយឥតគិតថ្លៃពិតមែន (Free)។',
          ],
        },
        {
          num: '៥.៣',
          title: 'ការគិតប្រាក់',
          subsections: [
            {
              num: 'ក)',
              title: 'ការគិតប្រាក់ជាប្រចាំឆ្នាំ',
              paragraphs: [
                'នៅពេលដែលបងប្អូនសម្រេចចិត្តចូលជាសមាជិក និងបានបញ្ចូលព័ត៌មានអំពីមធ្យោបាយទូទាត់ បងប្អូនអនុញ្ញាតឱ្យយើងធ្វើការគិតប្រាក់ពីបងប្អូន ទៅតាមចំនួនដែលបានបង្ហាញ និងព្រមព្រៀងដោយបងប្អូន សម្រាប់តែមួយគ្រានោះតែប៉ុណ្ណោះ។ គម្រោងនៃសមាជិកភាពរបស់យើង គឺសម្រាប់១២ខែ ដែលយើងនឹងធ្វើការគិតប្រាក់តែ១ដងសម្រាប់១២ខែ ហើយយើងមិនធ្វើការគិតប្រាក់ជាថ្មីម្ដងទៀតនៅចុងគ្រាដោយស្វ័យប្រវត្តិ នោះឡើយ។',
              ],
            },
            {
              num: 'ខ)',
              title: 'បម្រែបម្រួលនៃថ្លៃ',
              paragraphs: [
                'យើងរក្សាសិទ្ធិក្នុងការកែប្រែតម្លៃនៃសេវាកម្មរបស់យើង ទៅតាមភាពចាំបាច់ជាក់ស្ដែងរបស់យើង。 រាល់ការកែប្រែនៃតម្លៃនឹងចាប់មានប្រសិទ្ធភាពភ្លាម បន្ទាប់ពីការប្រកាសព័ត៌មានត្រូវបានផ្សាយចេញ។ ទោះជាយ៉ាងណាក៏ដោយយើងនឹងជម្រាបបងប្អូនឲ្យជ្រាបជាមុន។',
              ],
            },
            {
              num: 'គ)',
              title: 'ការស្នើសុំប្ដូរជាប្រាក់ត្រឡប់ទៅវិញ',
              paragraphs: [
                'រាល់ការទូទាត់នានាដែលបានសម្រេចទៅហើយ នោះមិនអាចប្ដូរជាប្រាក់ ឬជាឥណទានក្នុងរូបភាពណាផ្សេងនោះឡើយ។ យើង(ក្រុមការងារ)ក៏មិនមានតួនាទីឬបន្ទុក ក្នុងការដាក់ពាក្យស្នើសុំឱ្យមានការលើកលែង ឬការប្ដូរជាប្រាក់ឬឥណទានជូនបងប្អូននោះឡើយ។',
              ],
            },
            {
              num: 'ឃ)',
              title: 'ការបោះបង់សមាជិកភាព',
              paragraphs: [
                'នៅពេលដែលបងប្អូនចូលជាសមាជិក នៃកម្មវិធីទូរស័ព្ទដៃ E-School Cambodia រួចហើយ បងប្អូនមិនអាចបោះបង់ឬលុបចោលគម្រោងនោះ ដើម្បីស្នើសុំប្ដូរជាប្រាក់វិញនោះទេ។ យើងប្ដេជ្ញាក្នុងការបម្រើ សេវាកម្មជូនបងប្អូនឲ្យបានល្អបំផុត។ ប្រសិនបើបងប្អូនមានការមិនពេញចិត្តដោយប្រការណាមួយ យើងទទូចសុំឱ្យបងប្អូនផ្ដល់ដំណឹងមកយើង ដើម្បីឲ្យយើងអាចដោះស្រាយជូនបងប្អូន។',
              ],
            },
          ],
        },
      ],
    },
    {
      number: '៦',
      title: 'ការប្រើប្រាស់',
      paragraphs: [
        'កម្មវិធីទូរស័ព្ទដៃ E-School Cambodia មិនកម្រិតនូវអាយុនៃអ្នកប្រើប្រាស់នោះទេ។ បងប្អូនប្រជាជនកម្ពុជាដែលអាចស្ដាប់យល់នូវភាសាខ្មែរ ហើយបំណងចង់បន្តចំណេះដឹងខ្លួនឯងបន្ថែម អាចប្រើប្រាស់កម្មវិធីយើងបានទាំងអស់។ អ្វីដែលសំខាន់គឺបងប្អូនត្រូវមានទូរស័ព្ទដៃ ដែលមានសមត្ថភាពគ្រប់គ្រាន់ក្នុងការដំឡើងនូវកម្មវិធីនេះ ហើយត្រូវមានការតភ្ជាប់ទៅកាន់ប្រព័ន្ធអ៊ីនធឺណិតផងដែរ។ ការប្រើប្រាស់ទិន្នន័យអ៊ីនធឺណិតគឺជាចំណាយផ្ទាល់ខ្លួនរបស់អ្នកប្រើប្រាស់។',
        'មេរៀននិងទិន្នន័យផ្សេងៗដែលមាននៅក្នុងកម្មវិធីទូរស័ព្ទដៃ E-School Cambodia នេះគឺអនុញ្ញាតឱ្យប្រើប្រាស់សម្រាប់តែការរៀន និងអភិវឌ្ឍន៍ខ្លួនបន្ថែមតែប៉ុណ្ណោះ។ ហាមធ្វើការទាញយក ការថតជាវីដេអូ ឬជាសំឡេង និងហាមនូវរាល់ការថតចម្លងតាមគ្រប់បច្ចេកទេសនានា ក្នុងគោលបំណងចែកចាយបន្ត ឬយកទៅធ្វើអាជីវកម្មផ្ទាល់ខ្លួន ជាដាច់ខាត។ រាល់ទិន្នន័យទាំងអស់ដែលមាននៅក្នុងកម្មវិធីទូរស័ព្ទដៃនេះ គឺជាទ្រព្យកម្មសិទ្ធិបញ្ញារបស់ក្រុមហ៊ុន <strong>E-SCHOOL (CAMBODIA) CO.,LTD</strong> ដែលត្រូវបានការពារដោយច្បាប់នៃកម្មសិទ្ធិបញ្ញានៃព្រះរាជាណាចក្រកម្ពុជា។',
        'បងប្អូនត្រូវចាំថាសេវារបស់យើងពេលខ្លះត្រូវការផ្ញើលេខកូដបញ្ជាក់ពីលេខទូរស័ព្ទ ដោយការផ្ញើសារទៅកាន់លេខទូរស័ព្ទនោះ។ គណនីមួយត្រូវបានភ្ជាប់ដោយលេខទូរស័ព្ទមួយ ហើយអាចប្រើដើម្បីភ្ជាប់ចូលប្រើប្រាស់ សម្រាប់តែទូរស័ព្ទមួយក្នុងពេលតែមួយតែប៉ុណ្ណោះ។ សមាជិកភាពក៏ត្រូវបានផ្ដល់ជូនដោយយោងទៅតាម លេខទូរស័ព្ទដែលបានចុះឈ្មោះប្រើ ដោយបងប្អូនមិនអាចផ្ទេរសមាជិកភាពទៅកាន់លេខទូរស័ព្ទ (ឬគណនី)ផ្សេងទៀតនោះទេ។',
        'ដើម្បីបន្តប្រើប្រាស់កម្មវិធី E-School Cambodia បងប្អូនត្រូវតែកំពុងប្រើប្រាស់នូវជំនាន់ចុងក្រោយនៃកម្មវិធី។ តែអ្វីដែលល្អនោះគឺ កម្មវិធីយើងមានទំហំតូចហើយការទាញយកក៏មិនចំណាយពេលវេលាយូរដែរ។',
      ],
    },
    {
      number: '៧',
      title: 'គណនី',
      paragraphs: [
        'គណនីអ្នកប្រើប្រាស់កម្មវិធី ត្រូវបានតម្រូវឲ្យបង្កើតឡើងមុន តាមរយៈការចុះឈ្មោះដោយការវាយបញ្ចូលលេខទូរស័ព្ទ រួមជាមួយឈ្មោះប្រើប្រាស់ដែលបងប្អូនពេញចិត្ត។ ព័ត៌មានផ្ទាល់ខ្លួនដែលយើងយកពីបងប្អូន គឺលេខទូរស័ព្ទដែលបងប្អូនប្រើសម្រាប់ចុះឈ្មោះតែប៉ុណ្ណោះ។ គណនីមួយត្រូវបានភ្ជាប់ជាមួយលេខទូរស័ព្ទតែមួយប៉ុណ្ណោះ ហើយអាចប្រើប្រាស់លើឧបករណ៍(ទូរស័ព្ទដៃ)តែមួយប៉ុណ្ណោះ ក្នុងពេលតែមួយ។',
        'ការប្រើប្រាស់កម្មវិធី E-School Cambodia គឺក្នុងគោលបំណងប្រើប្រាស់ដើម្បីការអភិវឌ្ឍខ្លួន លើផ្នត់គំនិតនិងចំណេះដឹងបន្ថែម សម្រាប់បុគ្គលផ្ទាល់ខ្លួន ដូច្នេះបងប្អូនមិនគួរផ្ដល់គណនីរបស់បងប្អូន ទៅកាន់អ្នកដទៃនោះទេ ទោះបីជាមិត្តជិតស្និទ្ធក៏ដោយ។',
      ],
    },
    {
      number: '៨',
      title: 'ការប្រកាសទូទៅចំពោះការធានា និងចំណុចខ្វះខាត',
      paragraphs: [
        'ទៅតាមកម្រិតអតិបរមាអនុញ្ញាតដោយច្បាប់ជាធរមាន យើងព្យាយាមផ្ដល់ជូននូវសេវាកម្មល្អបំផុតតាមដែលយើងអាចធ្វើទៅបាន ហើយរាល់វីដេអូនិងមេរៀនទាំងអស់ដែលទាក់ទងនឹង សេវាកម្មនេះ ឬដំណើរការណាមួយផ្សេងទៀតដែលទាក់ទងនឹងយើង គឺត្រូវបានផ្ដល់ជូនដោយពុំគិតដល់ការខូចនិងដោយពុំមានការធានានោះទេ។ ក្នុងកម្រិតដែលអនុញ្ញាត មិនថាក្នុងករណីណាក៏ដោយ កម្មវិធី E-School Cambodia និងក្រុមហ៊ុន E-SCHOOL (CAMBODIA) CO.,LTD មិនមានទំនួលខុសត្រូវចំពោះអ្នកប្រើប្រាស់ លើការរងរបួសផ្ទាល់ខ្លួន ឬការខូចខាតជាពិសេស ដោយចៃដន្យ ឬដោយប្រយោលផ្សេងៗឡើយ។',
        'ប្រសិនបើមានប្រការណាមួយនៃលក្ខខណ្ឌក្នុងការប្រើប្រាស់នេះ ត្រូវបានចាត់ទុកថាគ្មានសុពលភាព មិនស្របច្បាប់ ឬមិនអាចអនុវត្តបាន ប្រការទាំងឡាយដែលនៅសល់ ត្រូវតែនៅមានសុពលភាព ស្របច្បាប់ និងអនុវត្តបានដដែល។',
      ],
    },
    {
      number: '៩',
      title: 'កម្មវិធីផ្ដល់ជូនពិសេស',
      paragraphs: [
        'ពេលខ្លះកម្មវិធីយើងអាចនឹងផ្ដល់ជូនបងប្អូននូវកម្មវិធីពិសេស ដែលមានលក្ខណៈជាការបញ្ចុះតម្លៃលើមេរៀនឬតម្លៃនៃសមាជិកភាព ដែលជាទូទៅនឹងមានភ្ជាប់មកជាមួយនូវលក្ខខណ្ឌមួយចំនួន។ បងប្អូនដែលជាអ្នកប្រើប្រាស់ទាំងអស់ នឹងទទួលបានព័ត៌មានអំពីការផ្ដល់ជូនទាំងនោះ។',
      ],
      subsections: [
        {
          num: '៩.១',
          title: 'សិទ្ធិថតចម្លង',
          paragraphs: [
            'E-School Cambodia អនុវត្តការការពារកម្មសិទ្ធិបញ្ញារបស់ម្ចាស់ដើម។ រាល់សេវាកម្មរបស់យើង ដែលរួមមានទិន្នន័យទាំងឡាយដែលយើងដាក់នៅក្នុងកម្មវិធី និងរាល់អ៊ីនធឺហ្វេស (interface) ដែលបានបង្កើតឡើង ដូចជាអត្ថបទ រូបភាព ក្រាហ្វិក ឡូហ្គោ រចនាបថ រូបថត សញ្ញាសម្គាល់ ប៊ូតុង សំឡេង វីដេអូ ទិន្នន័យឌីជីថល ចំណងក្រង ទិន្នន័យ និងសូហ្វែរ គឺជាទ្រព្យសម្បត្តិរបស់ E-School Cambodia ឬអ្នកផ្គត់ផ្គង់ទិន្នន័យរបស់យើង ហើយត្រូវបានការពារដោយច្បាប់ស្ដីពីកម្មសិទ្ធិបញ្ញា។',
          ],
        },
        {
          num: '៩.២',
          title: 'ពាណិជ្ជសញ្ញា',
          paragraphs: [
            'E-School Cambodia គឺជាពាណិជ្ជសញ្ញាដែលបានចុះបញ្ជី របស់ក្រុមហ៊ុន <strong>E-SCHOOL (CAMBODIA) CO., LTD</strong>។',
          ],
        },
        {
          num: '៩.៣',
          title: 'ការតវ៉ាចំពោះការបំពានសិទ្ធិថតចម្លង',
          paragraphs: [
            'ប្រសិនបើមានហេតុផលណាមួយដែលបងប្អូនជឿជាក់ថា សមិទ្ធផលឬកិច្ចការរបស់បងប្អូនត្រូវបានគេយកទៅផលិត ឬចែកចាយឡើងវិញតាមវិធីណាមួយដែលបំពានលើសិទ្ធីថតចម្លង ឬដឹងថាផលិតផលនៃការបំពាននោះ មាននៅលើកម្មវិធី E-School Cambodia សូមផ្ដល់ដំណឹងឲ្យយើងបានដឹងតាមរយៈ <strong>Facebook page: E-School Cambodia</strong>។',
          ],
        },
      ],
    },
    {
      number: '១០',
      title: 'ការប្រើប្រាស់ព័ត៌មានដែលអ្នកបានផ្ដល់មកយើង',
      paragraphs: [
        'កម្មវិធី E-School Cambodia មិនមានសិទ្ធិគ្រប់គ្រាន់ក្នុងការប្រើប្រាស់នូវព័ត៌មាន និងអ្វីទាំងឡាយណាដែលបងប្អូនបានបញ្ជូនមកយើង ក្នុងទម្រង់ជាការបញ្ចេញមតិ ការរអ៊ូរទាំ ការសរសើរ និងរួមបញ្ចូលទាំងការឆ្លើយតបក្នុងកម្រងសំណួរ សម្រង់មតិ ឬការផ្សាយព័ត៌មានទៅលើគេហទំព័រ Facebook របស់យើង ក៏ដូចជានៅក្នុងកម្មវិធីទូរស័ព្ទដៃផ្ទាល់ក្ដី។ យើងមិនទទួលយកព័ត៌មាន ឬយោបល់ក្នុងទម្រង់អ្វីមួយ ដែលបញ្ជូនមកយើងដោយយើងមិនបានធ្វើការស្នើសុំនោះឡើយ ហើយក៏មិនទទួលខុសត្រូវចំពោះភាពស្រដៀងគ្នា ទៅហ្នឹងព័ត៌មានដែលបានបញ្ជូនមកយើងនោះដែរ។',
      ],
    },
    {
      number: '១១',
      title: 'ជម្រើសនៃច្បាប់',
      paragraphs: [
        'លក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ ស្ថិតក្រោម និងត្រូវបានបកស្រាយ យោងតាមច្បាប់នៃព្រះរាជាណាចក្រកម្ពុជា ដោយពុំគិតពីវិវាទនៃច្បាប់ ឬបទប្បញ្ញត្តានានានោះទេ។ បងប្អូនក៏អាចមានសិទ្ធិទទួលបានការការពារ ចំពោះអ្នកប្រើប្រាស់មួយចំនួនផងដែរ ក្រោមច្បាប់នៅក្នុងប្រទេស ឬយុត្តាធិការរបស់ប្រទេសដែលបងប្អូនកំពុងរស់នៅ។',
      ],
    },
    {
      number: '១២',
      title: 'ការបម្រើអតិថិជន',
      paragraphs: [
        'យើងដែលជាក្រុមការងារនៃកម្មវិធី E-School Cambodia តាំងចិត្តបម្រើសេវាកម្ម និងដោះស្រាយរាល់បញ្ហាជូនអតិថិជន ដែលជាអ្នកប្រើប្រាស់កម្មវិធីទូរស័ព្ទដៃ របស់យើងឲ្យអស់លទ្ធភាព។ ប្រសិនបើបងប្អូនជួបនូវបញ្ហាអ្វីមួយ ហើយត្រូវការជំនួយពីយើង ពាក់ព័ន្ធជាមួយការចុះឈ្មោះ ការភ្ជាប់ចូលទៅគណនី សមាជិកភាព ឬសេវាកម្មផ្សេងៗ សូមផ្ញើសារអេឡិចត្រូនិកមកយើងតាមរយៈ <strong>Facebook page: E-School Cambodia</strong>។',
      ],
    },
    {
      number: '១៣',
      title: 'តំណភ្ជាប់',
      paragraphs: [
        'តំណភ្ជាប់មួយចំនួន ប្រភេទជា hyperlink ដែលមានប្រើនៅក្នុងសេវាកម្មរបស់យើង អាចនឹងនាំបងប្អូនទៅកាន់គេហទំព័រ ឬអ៊ីនធឺហ្វេសផ្សេងដែលមិនត្រូវបានគ្រប់គ្រង ដោយយើងផ្ទាល់។ ប៉ុន្តែដរាបណាកម្មវិធី E-School Cambodia មិនទាន់បានធ្វើការត្រួតពិនិត្យ លើប្រភពនោះទេ យើងមិនទទួលខុសត្រូវ លើទិន្នន័យ ឬគោលការណ៍ឯកជនរបស់ប្រភពទាំងនោះឡើយ។',
      ],
    },
    {
      number: '១៤',
      title: 'អសុពលភាពជាអន្លើ',
      paragraphs: [
        'បើបទប្បញ្ញត្តិណាមួយនៃលក្ខខណ្ឌនេះ គ្មានសុពលភាព ឬមិនអាចអនុវត្តបានដោយមូលហេតុណាមួយ ឬក្នុងកម្រិតណាមួយ បទប្បញ្ញត្តិដែលនៅសេសសល់ផ្សេងទៀត នឹងនៅតែមានសុពលភាព ស្របច្បាប់ និងអាចអនុវត្តបានពេញលេញដដែល មិនថាក្នុងរូបភាពណាក៏ដោយ។',
      ],
    },
    {
      number: '១៥',
      title: 'ទំនាក់ទំនងមកយើង',
      paragraphs: [
        'សម្រាប់សំណួរទាក់ទងនឹងលក្ខខណ្ឌនៃការប្រើប្រាស់នេះ សូមទាក់ទងមកយើង តាមរយៈលេខទូរស័ព្ទរបស់ក្រុមការងារ <strong>០១៥ ៣៧២ ៣៦៣ / ០៨៥ ៣៧២ ៣៦៣ / ០៦០ ៣៧២ ៣៦៣</strong> ឬផ្ញើជាលិខិតមកការិយាល័យរបស់យើងផ្ទាល់ ដែលស្ថិតនៅលើ <strong>អគារការិយាល័យ Kings View ផ្លូវកែវចិន្ដា ភូមិ ៣ សង្កាត់ជ្រោយចង្វា ខណ្ឌជ្រោយចង្វា រាជធានីភ្នំពេញ, ព្រះរាជាណាចក្រកម្ពុជា។</strong>',
      ],
    },
  ],
};

export default data;
